import { render } from "./CeremonyOverview.vue?vue&type=template&id=0dbed07a&scoped=true"
import script from "./CeremonyOverview.vue?vue&type=script&lang=js"
export * from "./CeremonyOverview.vue?vue&type=script&lang=js"

import "./CeremonyOverview.vue?vue&type=style&index=0&id=0dbed07a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dbed07a"]])

export default __exports__